import { render, staticRenderFns } from "./RsaPazienteSchedaValutazioneDisartriaListComponent.vue?vue&type=template&id=426d0fc5"
import script from "./RsaPazienteSchedaValutazioneDisartriaListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSchedaValutazioneDisartriaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports